<template>
  <div class="container">
    <top-nav></top-nav>
    <Header>
      <div class="header_main">
        <Menu ref="side_menu"
              mode="horizontal"
              theme="light"
              :active-name="active"
              class="header_menu"
              :open-names="open"
              @on-select="navigateTo">
          <div class="layout-logo">
            <a @click="goPage('')">
              <img class="logo"
                   :src="logo"
                   onerror="@/assets/images/LOGO.png">
            </a>
            <span class="title primary">买 家 工 作 台</span>
          </div>
          <div class="layout-nav">
            <MenuItem :name="item.path"
                      v-for="(item,index) in menuList"
                      :key="index">
            {{item.title}}
            </MenuItem>
          </div>
        </Menu>
      </div>
    </Header>
    <div class="index_container">
      <router-view class="index_content"
                   :selectValue=active></router-view>
    </div>
  </div>
</template>

<script>
import TopNav from '@/layout/components/Header/TopNav'

export default {
  name: 'index',
  components: {
    TopNav
  },
  data() {
    return {
      logo: require('@/assets/images/LOGO.png'),
      menuList: [
        {
          title: '首页',
          path: 'indexCount'
        },
        {
          title: '交易管理',
          path: 'order'
        },
        {
          title: '客户服务',
          path: 'afterSaleAdmin'
        },
       /* {
          title: '财务中心',
          path: 'capitalLi'
        },*/
        {
          title: '收藏中心',
          path: 'collectGoods'
        },

        {
          title: '浏览足迹',
          path: 'browseRecord'
        },
        // {
        //   title: '我的推荐',
        //   path: '4'
        // },
        {
          title: '账户设置',
          path: 'essentialInfo'
        }
      ],
      open: [],
      active: ''
    }
  },
  mounted() {
    //匹配到的父级name， array
    this.active = this.$route.name
    this.$nextTick(() => {
      this.$refs.side_menu.updateOpened()
      this.$refs.side_menu.updateActiveName()
    })
    if (this.$store.state.mallLogo) {
      this.logo = this.$store.state.mallLogo
    }
  },
  methods: {
    navigateTo(name) {
      this.$router.push({ name: name })
    },
    goPage (url) {
      // 前往页面
      //console.log("跳转到商品详情")
      window.open(this.DOMAIN_URL+url, '_blank')
    }
  },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.active = this.$route.name
      },
      // 深度观察监听
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background: #f5f5f5;
  /*height: 100%;*/
  min-height: 100vh;
}

.header_main {
  width: 1200px;
  margin: 0 auto;
  padding: 0 10px;
}

.index_container {
  padding: 16px 0 50px;
  .index_content {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
}

.header_menu {
  display: flex;
  height: 64px;
  line-height: 64px;
  z-index: 0;
}

.layout-logo {
  img {
    width: auto;
    height: 40px;
    vertical-align: middle;
  }

  .title {
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
  }
}

.layout-nav {
  margin-left: 40px;

  li {
    padding: 0 16px;
  }
}
</style>
<style>
.ivu-menu-vertical.ivu-menu-light:after {
  background: #fff !important;
}

.layout-nav .ivu-menu-item {
  font-size: 14px;
  font-weight: 500;
}
</style>
